import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d62c6f8e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page" }
const _hoisted_2 = { class: "top-bar" }
const _hoisted_3 = { class: "bottom-bar" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "orbitron-font main-title" }, [
  /*#__PURE__*/_createTextVNode(" G"),
  /*#__PURE__*/_createElementVNode("span", null, "AI"),
  /*#__PURE__*/_createTextVNode("A "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Discord Role Test ")
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "main-content" }, [
  /*#__PURE__*/_createTextVNode(" GET SORTED INTO "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" YOUR DESTINED DISCORD ROLE ")
], -1))
const _hoisted_6 = { class: "btns-box" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "grid-content" }, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "grid-content" }, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "grid-content" }, null, -1))

import { useRouter } from "vue-router";
import LogoBar from '@/components/LogoBarComponent.vue'
import ArrowDownUp from '@/components/ArrowDownUp.vue'
import ButtonHome from '@/components/ButtonHomeComponent.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'HomePage',
  setup(__props) {

const router = useRouter();

const onStart = () => {
  router.replace({ path: '/process' })
}

return (_ctx: any,_cache: any) => {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(LogoBar)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _hoisted_5,
      _createVNode(ArrowDownUp),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_el_row, { gutter: 0 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, { span: 6 }, {
              default: _withCtx(() => [
                _hoisted_7
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 12 }, {
              default: _withCtx(() => [
                _hoisted_8,
                _createVNode(ButtonHome, {
                  text: "",
                  onClick: onStart
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 6 }, {
              default: _withCtx(() => [
                _hoisted_9
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ])
  ]))
}
}

})